export const startOfRamadan = new Date("2/18/2026").setHours(0, 0, 0, 0);
export const endOfRamadan = new Date("3/19/2026").setHours(0, 0, 0, 0);
